import { Injectable } from '@angular/core';
import { CreateProcessUserService } from 'src/app/api-shared/process-status/create/create-process-user.service';
import { SharedServiceCompleted } from '@apiShared/shared-service/shared-services.service.compontent';
import { CookieUtil } from '@utils/cookies';
import { RedirectProcessStatus } from '../redirect/redirect-process-status';
import { SessionStorageUtil } from '@utils/sessionStorage';
import { GtmService } from '@apiShared/analytics/gtm';

@Injectable({
  providedIn: 'root',
})
export class CreateProcessUser {
  constructor(
    private post_create_user: CreateProcessUserService,
    public cookies: CookieUtil,
    private _gta_events: GtmService,
    private _sessionstorage: SessionStorageUtil,
    private _redirect_proccess_user: RedirectProcessStatus,
    private _CompletedSharedServices: SharedServiceCompleted,
  ) {}
  public CreateProcess_Helper(objParamaters: any): Promise<any> {
    return new Promise((resolve) => {
      this.post_create_user.CREATE_PROCESS_USER(objParamaters.data, objParamaters.idToken).then((data: any) => {
        
        let status = data.status;
        let response = data.body;
        if (status === 201 || status === 200) {
          this.TriggerEventsCreateProccess(objParamaters?.data);
          /* Subimos el id del proceso creado a una cookie */
          this.cookies.save('id_process', response.process_uuid, 1);
          /* Removemos variable de bonus */
          this._sessionstorage.delete('event_bonus');
          /* Redireccionamos al formato de vinculación dependiendo del banco del nombre */
          this._redirect_proccess_user.RedirectProcessUser_Helper({
            idProcess: this.cookies.get('id_process'),
            idToken: this.cookies.get('id_token_user'),
            modal: objParamaters.modal,
          });
          /*
            Comunicaremos a demas componentes que se ha creado el proceso exitosamente, por tanto, activaremos funciones.
            por ejemplo: en el header, volveremos activar la información del usuario para ver el nombre en el menu
          */
          this._CompletedSharedServices.setFunctionCompleted({
            function_completed: true,
          });

          this._gta_events.triggerGTMEvent('**_create_processes', 'MyProcessesComponent');
          this.deleteCookiesBonus();
          resolve(200);
        } else {
          resolve(status);
        }
      });
    });
  }

  deleteCookiesBonus(): void {
    if (this.cookies.check('promo-bonus')) {
      this.cookies.delete('promo-bonus');
    }
    if (this.cookies.check('refcode')) {
      this.cookies.delete('refcode');
    }
  }

  TriggerEventsCreateProccess(objParamaters: any) {
    /* Activamos evento de Creaciòn de proceso */
    let environment_simulate = objParamaters?.environment_simulate;
    this._gta_events.triggerGTMEvent(`ga_${environment_simulate}_btn_crear_deal_general`, 'CreateProcessUser');
    this._gta_events.triggerGTMEvent(
      `ga_${environment_simulate}_btn_crear_deal_${objParamaters?.bank_id}`,
      'CreateProcessUser',
    );
  }
}
